import { PageEntityInterface } from '../types/base-entity-interface'
import { BaseEntityWithChildIdsInterface } from '../schemas/base-entity.schema'

export function isEntityWithChildIds(
  entity: PageEntityInterface,
): entity is BaseEntityWithChildIdsInterface {
  return 'childIds' in entity
}
